import { render, staticRenderFns } from "./medicalRecordForm.vue?vue&type=template&id=23f8c342&"
import script from "./medicalRecordForm.vue?vue&type=script&lang=js&"
export * from "./medicalRecordForm.vue?vue&type=script&lang=js&"
import style0 from "./medicalRecordForm.vue?vue&type=style&index=0&id=23f8c342&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports